import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './CustomFormFields.scss';
import { Textarea } from '@salesforce/design-system-react';

export const MediumText = ({ enabled, required, label, fieldName, length, handleChange, error, defaultValue }) => {
  const [mediumText, setMediumText] = useState('');

  useEffect(() => {
    setMediumText(defaultValue);
  }, [defaultValue]);

  return (
    <div className='time-mediumtext input-text'>
      <Textarea
        className={'time-mediumtext-textarea'}
        type='text'
        label={label}
        disabled={!enabled}
        required={required}
        name={fieldName}
        onChange={(e) => {
          setMediumText(e.target.value);
          handleChange(e, { fieldName, value: e.target.value });
        }}
        maxLength={length}
        errorText={error}
        value={mediumText}
      />
    </div>
  );
};

MediumText.propTypes = {
  enabled: PropTypes.bool,
  required: PropTypes.bool,
  label: PropTypes.string,
  fieldName: PropTypes.string,
  length: PropTypes.string,
  handleChange: PropTypes.func,
  error: PropTypes.string,
  defaultValue: PropTypes.string,
};
